/**
 * Auth0 login redirect — explicit authorizationParams for Universal Login.
 */
import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { resolveRedirectUri } from './auth0-config';

export function getAuthorizationParams(): {
  redirect_uri: string;
  audience?: string;
} {
  const env = import.meta.env as {
    VITE_AUTH0_REDIRECT_URI?: string;
    VITE_AUTH0_AUDIENCE?: string;
  };
  const audience = env.VITE_AUTH0_AUDIENCE?.trim();
  return {
    redirect_uri: resolveRedirectUri(env.VITE_AUTH0_REDIRECT_URI ?? ''),
    ...(audience ? { audience } : {}),
  };
}

export function useLogin() {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();

  const login = useCallback(
    async (returnTo = '/app') => {
      const authorizationParams = getAuthorizationParams();
      await loginWithRedirect({
        appState: { returnTo },
        authorizationParams: {
          ...authorizationParams,
          prompt: 'login',
        },
      });
    },
    [loginWithRedirect],
  );

  return { login, isAuthenticated, isLoading, error };
}
